import React, { useRef, useState, useCallback, useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, Polyline } from "react-leaflet";
import L from "leaflet";
import CommonDropdown from "../common/common_dropDown";
import { getStopLocationsApi, getTripHistoryRouteApi, getTripPlanRouteApi } from "./live-view-api";
import polyline from "@mapbox/polyline";
import stopPinImg from "../../assets/png/location-pin.png";
// Optional: Custom marker icon
const customIcon = L.icon({
  iconUrl: "https://cdn-icons-png.flaticon.com/512/684/684908.png",
  iconSize: [35, 35],
  iconAnchor: [17, 35],
  popupAnchor: [0, -35],
});

export const MultiRouteMap = () => {
  const apiUrl = process.env.REACT_APP_API_URL;

  const route1 = [
    [51.505, -0.09],
    [48.8566, 2.3522],
    [41.9028, 12.4964],
  ];

  const route2 = [
    [40.7128, -74.006],
    [42.3601, -71.0589],
    [38.9072, -77.0369],
  ];
  const [tripOption, setTripOption] = useState(null);
  const [stopPinLocation, setStopPinLocation] = useState([]);
  const [deliveryPinLocation, setDeliveryPinLocation] = useState([]);
  const [polylinePlanned, setPolylinePlanned] = useState([]);
  const [polylineHistory, setPolylineHistory] = useState([]);

  const getStopLocations = async (tripId) => {
    try {
      const response = await getStopLocationsApi(tripId);

      if (response.data.success === true) {
        const tripDetails = response.data.trip ?? {};

        if (tripDetails["stopadderss"].length > 0) {
          tripDetails["stopadderss"].forEach((marker, index2) => {
            //const [lat, lng] = decoded[index2];
            if (marker["latitude"] == null || marker["longitude"] == null || marker["latitude"] === "" || marker["longitude"] === "") {
            } else {
              setStopPinLocation([...stopPinLocation, marker]);
            }
          });
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const getTripPlanRoute = async (tripId) => {
    try {
      const response = await getTripPlanRouteApi(tripId);

      if (response.data.success === true) {
        const routeList = response.data.response ?? [];
        console.log("routeList", routeList.length);
        if (routeList.length > 0) {
          _createPolylines(routeList, "customer");
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };

  const getTripHistoryRoute = async (tripId) => {
    try {
      const response = await getTripHistoryRouteApi(tripId);

      if (response.data.success === true) {
        const routeList = response.data.response ?? [];
        console.log("routeList", routeList.length);
        if (routeList.length > 0) {
          _createPolylines(routeList, "history");
        }
      } else {
      }
      return response.data;
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
    }
  };
  const _createPolylines = (routeList, type) => {
    // Collect markers from all responses

    routeList.forEach((item, index) => {
      console.log(`index..... ${index}`);
      if (item["points"] !== null && item["points"] !== "") {
        try {
          let polylineList = [];
          const decoded = polyline.decode(item["points"]);
          console.log(decoded);
          if (decoded.length > 0) {
            decoded.forEach((coords, index2) => {
              //const [lat, lng] = decoded[index2];
              if (type === "history" && item["plot"] != null && item["plot"] === true && index2 === 0) {
                setDeliveryPinLocation([...deliveryPinLocation, coords]);
              }
              polylineList.push(coords);
            });
            if (polylineList.length > 0) {
              const point = {
                id: `poly${type}${index}`, // Unique ID
                positionList: polylineList,
              };
              if (type === "history") {
                setPolylineHistory([...polylineHistory, point]);
              } else {
                setPolylinePlanned([...polylineHistory, point]);
              }
            }
          }
          /* } */
        } catch (parseError) {
          console.error("Error parsing response at index", index, parseError);
        }
      }
    });
    //setDeliveryPinLocation(allMarkers);
  };

  const createCustomMarker = (text) =>
    L.divIcon({
      className: "custom-icon",
      html: `
      <div style="position: relative; display: inline-block;">
        <!-- Your image from assets -->
        <img src="${stopPinImg}" style="width:40px;height:40px;" />
        
        <!-- Text overlay -->
        <span style="
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 14px;
          font-weight: bold;
        ">
          ${text}
        </span>
      </div>
    `,
      iconSize: [40, 40], // size of whole div
      iconAnchor: [20, 40], // bottom center
      popupAnchor: [0, -40],
    });

  return (
    <div style={{ position: "relative", zIndex: 1 }}>
      <MapContainer center={[30, 0]} zoom={2} style={{ height: "100vh", width: "100vw" }}>
        <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" attribution='&copy; <a href="href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>' />

        {/* Markers for route 1 */}
        {route1.map((coord, index) => (
          <Marker key={`r1-${index}`} position={coord} icon={customIcon}>
            <Popup>Route 1 - Point {index + 1}</Popup>
          </Marker>
        ))}

        {/* Markers for route 2 */}
        {route2.map((coord, index) => (
          <Marker key={`r2-${index}`} position={coord} icon={customIcon}>
            <Popup>Route 2 - Point {index + 1}</Popup>
          </Marker>
        ))}
        {stopPinLocation.map((coord, index) => (
          <Marker key={`Stop${index}`} position={coord} icon={createCustomMarker(index + 1)}>
            <Popup>Stop {index + 1}</Popup>
          </Marker>
        ))}
        {deliveryPinLocation.map((coord, index) => (
          <Marker key={`delivery-${index}`} position={coord} icon={customIcon}>
            <Popup>Route 2 - Point {index + 1}</Popup>
          </Marker>
        ))}
        {polylinePlanned.map((poly, index) => (
          <Polyline key={`${poly.id}`} positions={poly.positionList} color="#FF0000" weight={5} />
        ))}
        {polylineHistory.map((poly, index) => (
          <Polyline key={`${poly.id}`} positions={poly.positionList} color="#008000" weight={4} />
        ))}
        {/* Polylines */}
        {/* <Polyline positions={route1} color="blue" weight={4} />
        <Polyline positions={route2} color="red" weight={4} dashArray="5,10" /> */}
      </MapContainer>
      <div
        style={{
          position: "absolute",
          top: "0px",
          left: "60px",

          zIndex: 999,
        }}
      >
        <div>
          <CommonDropdown
            apiUrl={`${apiUrl}trips/autosuggestion?module=tripcost&fromDate=&toDate=`}
            placeholder="Select"
            value={tripOption}
            onSelect={(item) => {
              setTripOption(item);
              getStopLocations(item.value);
              getTripPlanRoute(item.value);
              getTripHistoryRoute(item.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};
